import React from 'react'
import ConactUsHeader from '../organisms/ContactUsHeader'
import Footer from '../organisms/Footer'
import useScrollToTop from '../../hooks/useScrollToTop'
import FaqBody from '../organisms/FaqBody'
const FaqPage = () => {
  useScrollToTop()
  return (
    <div className='bg-gray-100'>
      <ConactUsHeader />
      <FaqBody />
      <Footer />
    </div>
  )
}

export default FaqPage
